import { jsx as t } from "react/jsx-runtime";
import { c as l } from "react/compiler-runtime";
import { FormLabel as s } from "@mui/material";
const a = (m) => {
  const o = l(4);
  let r;
  o[0] !== m ? ({
    ...r
  } = m, o[0] = m, o[1] = r) : r = o[1];
  let e;
  return o[2] !== r ? (e = /* @__PURE__ */ t(s, { ...r }), o[2] = r, o[3] = e) : e = o[3], e;
};
export {
  a as FormLabel
};
